import { Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { RowDecorator } from '../Enum/TableDecorator';

interface Scopes {
    [index: string]: Row[];
}

const createScopedRow = (scopeName: string, amountCells: number): Row => {
    const row = { cells: [], decorator: RowDecorator.ScopeRow } as Row;
    for (let i = 0; i < amountCells; i++) {
        row.cells.push(i === 0 ? { value: scopeName } : { value: null });
    }
    return row;
};

const scopeTableData = (data: Row[]): Row[] => {
    data.forEach(row => {
        if (row.scope === undefined) {
            throw new Error('Please provide scope for row in scopable table.');
        }
    });

    const scopes: Scopes = {};
    data.forEach(row => {
        if (typeof scopes[row.scope || ''] === 'undefined') {
            scopes[row.scope || ''] = [];
        }
        scopes[row.scope || ''].push(row);
    });

    const cellCount = data[0].cells.length;
    const scopedData: Row[] = [];

    Object.keys(scopes).forEach(key => {
        scopedData.push(createScopedRow(key, cellCount));
        scopes[key].forEach(row => scopedData.push(row));
    });

    return scopedData;
};

export default scopeTableData;
